import currencies from './Currencies.json';

export default {
  allCurrencies: currencies,
  exchangeRates: [],
  exchangeRate: undefined,
};
